import { twMerge } from 'tailwind-merge';

import type { NormalizedBarChartData } from '../shared/types';

import { colorForSeries } from '../shared/chart-palette';

export interface BarChartLegendProps {
  series: NormalizedBarChartData['series'];
  className?: string;
}

export const BarChartLegend = ({ series, className }: BarChartLegendProps) => {
  if (series.length <= 1) return null;

  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles -- Safari VoiceOver strips list role with list-none
    <ul
      role="list"
      aria-label="Chart series"
      className={twMerge(
        'flex flex-wrap items-center gap-2.5 m-0 p-0 list-none font-text text-xs text-gray-500',
        className
      )}
    >
      {series.map((singleSeries, seriesIndex) => (
        <li
          key={`${seriesIndex}-${singleSeries.label}`}
          className="flex items-center gap-1 min-w-0"
        >
          <span
            aria-hidden="true"
            className="inline-block w-2.5 h-2.5 rounded-full shrink-0"
            style={{
              backgroundColor: colorForSeries(seriesIndex, series.length),
            }}
          />
          <span className="min-w-0 break-words">{singleSeries.label}</span>
        </li>
      ))}
    </ul>
  );
};
